import { Component, NgZone, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { DownloadAppComponent } from "./download-app/download-app.component";
import { MapLoaderService } from './services/map-loader.service';
import { Meta, Title } from '@angular/platform-browser';

declare global {
  interface Window {
    initMap: () => void;
  }
}


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})

export class AppComponent implements OnInit {

  baseApiUrl = environment.baseApiUrl;

  isMapReady = false;

  constructor(
    private router: Router, 
    private mapLoader: MapLoaderService,
    private meta: Meta,
    private title: Title,
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      window.scrollTo(0, 0);
    });

    window.initMap = this.initMap.bind(this);
    this.mapLoader.load();

    // Page Title
    this.title.setTitle('NongHyup Finance Cambodia');

    // Meta Description
    this.meta.addTag({
      name: 'description',
      content: 'NongHyup Finance Cambodia Plc'
    });

    // Meta keywords (Google doesn't use them much, but other engines may)
    this.meta.addTag({
      name: 'keywords',
      content: 'NH Finance, Nonghyup, NongHyup Finance, Nonghyup Finance Cambodia, Nonghyup Website'
    })
  }

  // loadGoogleMapsScript(): void {
  //   if (document.getElementById('google-maps-api-script')) {
  //     return;
  //   }
  
  //   const script = document.createElement('script');
  //   script.id = 'google-maps-api-script';
  //   script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&callback=initMap&v=weekly`;
  //   script.async = true;
  //   script.defer = true;
  //   script.onload = () => {
  //     console.log('Google Maps script has loaded successfully');
  //   };
  //   script.onerror = (error) => {
  //     console.error('Google Maps script loading error:', error);
  //   };
  
  //   // Bind initMap to window object to make it globally accessible
  //   window.initMap = this.initMap.bind(this);
  
  //   document.head.appendChild(script);
  // }

  
  initMap(): void {
    console.log('Google Maps API callback is triggered');
    
    const mapOptions = {
      center: { lat: 12.3798, lng: 104.9317 },  // Example coordinates (update with your desired location)
      zoom: 7, // Set the zoom level
    };
  
    const map = new google.maps.Map(document.getElementById('map') as HTMLElement, mapOptions);
    console.log('Google Maps has loaded and the map is initialized');
  }
  

}
